import React, { useState, useEffect } from 'react';
import localStorageCustom from '../../utilitarios/localStorage';
import device from '../../utilitarios/device';
const AuthContext = React.createContext();


const AuthProvider = (props) => {
    const [userToken, setuserToken] = useState(null);
    const [carritoProdctos, setcarritoProdctos] = useState(0);
    const [userRazonSocial, setuserRazonSocial] = useState("RazoN Social");
    const [userApellidoNombre, setuserApellidoNombre] = useState("");
    const [userCorreo, setuserCorreo] = useState("");
    const [dealerAlertas, setdealerAlertas] = useState(null);
    const [codigoDispositivo, setCodigoDispositivo] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [hideNav, setHideNav] = useState(false);
    const [mostrarOfertas, setmostrarOfertas] = useState(false);
    const [localEnvio, setLocalEnvio] = useState(0);

    const getStorageToken = async () => {
        let token = null;
        // device.prototype.Mac = device.prototype.getMac();
        localStorageCustom.prototype.token = localStorageCustom.prototype.getToken();
        if (localStorageCustom.prototype.token) {
            token = localStorageCustom.prototype.token;
            setIsLoggedIn(true);
            setuserRazonSocial(localStorageCustom.prototype.getRazonSocial());
        }
        setuserToken(token);
    };

    useEffect(() => {
        getStorageToken();
    });
    return (
        <AuthContext.Provider
            value={{
                userToken,
                setuserToken,
                carritoProdctos,
                setcarritoProdctos,
                userRazonSocial,
                setuserRazonSocial,
                dealerAlertas,
                setdealerAlertas,
                userApellidoNombre,
                setuserApellidoNombre,
                userCorreo,
                setuserCorreo,
                codigoDispositivo,
                setCodigoDispositivo,
                isLoggedIn,
                setIsLoggedIn,
                hideNav,
                setHideNav,
                getStorageToken,
                mostrarOfertas,
                setmostrarOfertas,
                localEnvio, setLocalEnvio
            }}
        >
            {props.children}
        </AuthContext.Provider>
    )
}

export { AuthProvider, AuthContext };